import { SignIn, SignUp } from '@clerk/clerk-react';
import { useRef } from 'react';

import { ProgressBar } from '@/components/ui/progress-bar';

import { clerkAppearance } from './clerkAppearance';
import { useClerkSignUpProgress } from './useClerkSignUpProgress';

export function SignInPage() {
  return (
    <div className="h-full overflow-y-auto bg-background">
      <div className="flex min-h-full items-center justify-center px-4 py-10">
        <div className="w-full max-w-sm">
          <SignIn
            routing="path"
            path="/sign-in"
            signUpUrl="/sign-up"
            appearance={clerkAppearance}
          />
        </div>
      </div>
    </div>
  );
}

export function SignUpPage() {
  const formContainerRef = useRef<HTMLDivElement>(null);
  const progress = useClerkSignUpProgress(formContainerRef);

  return (
    <div className="flex h-full flex-col overflow-y-auto bg-background">
      {/* Header-bar progress — mirrors the pickem sign-up header */}
      <div className="w-full border-t border-border bg-card px-4 py-6">
        <div className="mx-auto w-full max-w-sm">
          <ProgressBar value={progress} variant="flat" />
        </div>
      </div>

      <div className="flex flex-1 justify-center px-4 py-10">
        <div ref={formContainerRef} className="w-full max-w-sm">
          <SignUp
            routing="path"
            path="/sign-up"
            signInUrl="/sign-in"
            appearance={clerkAppearance}
          />
        </div>
      </div>
    </div>
  );
}
